export interface TLFRProps {
  nombreApellido?: string;
  activo?: unknown;
}

export const getTechniciansFilter = (data: TLFRProps) => {
  const rawActivo = data?.activo;
  const activoSelected = Array.isArray(rawActivo) ? rawActivo?.[0] : rawActivo;
  let activoParsed: boolean | undefined;
  if (typeof activoSelected === "boolean") {
    activoParsed = activoSelected;
  } else if (activoSelected === "true") {
    activoParsed = true;
  } else if (activoSelected === "false") {
    activoParsed = false;
  }

  return {
    ...(data?.nombreApellido
      ? {
          nombreApellido: data?.nombreApellido,
        }
      : {}),
    ...(typeof activoParsed === "boolean" ? { activo: activoParsed } : {}),
  };
};
